import { css, cx } from '@linaria/atomic';
import type { IconProps } from '../../../../icon/Icon.component';
import { CaretDownIconSmall } from '../../../../icon/icons-small/caret-down-small';
import { DropdownFieldProps } from './types';

const dropdownIconIconStyle1 = css`
  cursor: default;
  pointer-events: none;
  transition: transform 250ms ease-out;
`;

const dropdownIconIconStyle2 = css`
  transform: rotate(180deg);
`;

type Props = Pick<DropdownFieldProps, 'active' | 'icon'> & { color?: IconProps['color'] };

export const DropdownIcon = ({ active, icon, color = 'default' }: Props) => {
  const Icon = icon ?? CaretDownIconSmall;
  return <Icon color={color} className={cx(dropdownIconIconStyle1, !icon && active && dropdownIconIconStyle2)} />;
};
